const translation = {
    day: "Dan",
    week: "Nedelja",
    month: "Mesec",
	today_button: {
		"today": "Današnji dan"
	},
    all_day_panel: {
        "allDay": "Čitav dan"
    },
	appointment_form: {
		"detailsLabel": "Detalji",
		"allDayLabel": "Čitav dan",
		"titleLabel": "Naziv",
		"commitCommand": "Sačuvajte",
        "moreInformationLabel": "Više informacija",
        "repeatLabel": "Ponavljanje",
        "notesLabel": "Beleške",
        "never": "Nikada",
        "daily": "Dnevno",
        "weekly": "Nedeljno",
        "monthly": "Mesečno",
        "yearly": "Godišnje",
        "repeatEveryLabel": "Ponovi svaki",
        "daysLabel": "dan",
        "endRepeatLabel": "Završi ponavljanje",
        "onLabel": "Na",
        "afterLabel": "Nakon",
        "occurrencesLabel": "ponavljanje(a)",
        "weeksOnLabel": "Nedelja"
	},
    dialog_confirmation: {
        "discardButton": "Odbacite",
        "deleteButton": "Obrišite",
        "cancelButton": "Odustanite",
        "confirmDeleteMessage": "Da li ste sigurni da želite da obrišete ovaj termin?",
        "confirmCancelMessage": "Odbacite nesačuvane izmene?"
    }
}

export default translation;
